module.exports = __webpack_public_path__ + "img/1f04cc7.jpg";